import { UserUserIdAppealGetInputModel } from "../../api/v1/user/[user_id]/appeal/GetInputModel"
import { getUserUserIdAppeal } from "../../api/v1/user/[user_id]/appeal/get"
import { UserAppeal } from "./UserAppeal"
import { adaptUserAppeal } from "./adaptUserAppeal"

export const fetchUserAppeal = (userId: string): Promise<UserAppeal> => {
  const model = new UserUserIdAppealGetInputModel({ userId })

  return getUserUserIdAppeal(model).then((res) => {
    return adaptUserAppeal(res ? res : null)
  })
}
